class ProductItemModel {
  title = null
  cover = null
  brief = null
  publishDate = null
  price = 0
  initialPage = null
  chapterNumber = null
  language = 'pt'
  fileFormat = null
  doiLink = ''
  data = null
  content = null
  contentText = ''
  customerCourtesy = false
  subscriberCourtesy = false
  category = null
  authors = []
  digitalProduct = true
  keywords = []
  length = null
  fileType = null
}

export default () => new ProductItemModel()
